// src/api/auth.js
// Thin wrappers over the /auth endpoints. Each returns the unwrapped data
// payload (res.data.data) or throws with a normalised { message, code }.

import client, { tokenStore } from "./client";

const unwrap = (res) => res.data.data;

// turn an axios error into { message, code } using the backend envelope
const normalizeError = (err) => {
  const body = err.response?.data;
  return {
    message: body?.error || "Something went wrong. Try again.",
    code: body?.code || "NETWORK",
    status: err.response?.status || 0,
  };
};

export const login = async (email, password) => {
  try {
    const data = unwrap(await client.post("/auth/login", { email, password }));
    tokenStore.set(data.tokens);
    return data.user;
  } catch (err) {
    throw normalizeError(err);
  }
};

// register a new user or practitioner. mirrors login: stores the returned
// tokens so the follow-up me() call is authenticated.
export const register = async ({ name, email, phone, password, role, referral_code }) => {
  const body = { name, email, phone, password };
  if (role === "practitioner") body.role = "practitioner";
  // referral applies to everyone now, not just practitioners
  if (referral_code) body.referral_code = referral_code;
  try {
    const data = unwrap(await client.post("/auth/register", body));
    tokenStore.set(data.tokens);
    return data.user;
  } catch (err) {
    throw normalizeError(err);
  }
};

// live check on the register form. never throws, so a network problem cannot
// block someone from signing up.
export const validateReferral = async (code) => {
  try {
    return unwrap(await client.post("/auth/validate-referral", { code }));
  } catch {
    return { valid: false };
  }
};

export const me = async () => {
  try {
    return unwrap(await client.get("/auth/me"));
  } catch (err) {
    throw normalizeError(err);
  }
};

export const logout = async () => {
  const refreshToken = tokenStore.refresh;
  try {
    if (refreshToken) await client.post("/auth/logout", { refreshToken });
  } catch (e) {
    // best effort; clear locally regardless
  } finally {
    tokenStore.clear();
  }
};
